import AttributesCoVLightField from './AttributesCoVLightField'

export default AttributesCoVLightField
